import styled from "styled-components";
import { Link } from "react-router-dom";

interface SubmenuProps {
  isSubmenuOpen: boolean;
  onClick?(event: any): void;
  items: {
    label: string;
    url: string;
  }[];
}

interface SubmenuContentProps {
  isSubmenuOpen: boolean;
}

export function Submenu({ items, isSubmenuOpen, onClick }: SubmenuProps) {
  return (
    <Content isSubmenuOpen={isSubmenuOpen}>
      {items.map((item, index) => (
        <Item key={index}>
          <LinkUI to={`/${item.url}`} onClick={(e) => {e.stopPropagation(); onClick && onClick(null)}}  reloadDocument={false} >
            {item.label}
          </LinkUI>
        </Item>
      ))}
    </Content>
  )
};

const Content = styled.ul<SubmenuContentProps>`
  position: absolute;
  top: 100px;
  left: 0;
  width: 166px;
  list-style-type: none;
  transition: all 0.2s;
  background-color: ${({ theme }: any) => theme.colors.gray.dark};
  padding: 10px;
  opacity: 0;
  visibility: hidden;

  &::before {
    content: "";
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 8px 8px 8px;
    border-color: ${({ theme }: any) => `transparent transparent ${theme.colors.gray.dark} transparent`};
    position: absolute;
    top: -8px;
    left: 20px;
  }

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    position: static;
    flex-basis: 100%;
    opacity: 1;
    visibility: visible;
    background-color: transparent;
    transition: all 0.3s ease-in-out;
    overflow: hidden;
    padding: 0;
    max-height: ${({ isSubmenuOpen }) => isSubmenuOpen ? '1000px' : '0px'};
    border-bottom: ${({ theme }) => `2px solid ${theme.colors.blue.dark}`};

    &::before {
      content: none;
    }
  }
`;

const Item = styled.li`
  padding: 3px 10px;
  border-bottom: ${({ theme }: any) => `1px dotted ${theme.colors.gray.darker}`};
  font-size: 18px;

  &:last-child {
    border: none;
  }

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    border: none;
    font-size: 20px;
    padding: 8px 10px;
  }
`;

const LinkUI = styled(Link)`
  color:  ${({ theme }: any) => theme.colors.black.medium};
  text-decoration: none;

  &:hover, &:active {
    opacity: 0.7;
  }

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    color: #fff;
  }
`;